import TrashFill from './TrashFill';

export default TrashFill;
